<app-breadcrumb [title]="'Mantenimiento de Vehículos'" [items]="['Implementación']"
    [active_item]="'Mantenimiento de Vehículos'">
</app-breadcrumb>

<div class="container-fluid">
  <div class="card">

    <div class="card-header bg-primary text-white">
      <h5 class="mb-0">
        <strong>MANTENIMIENTO DE VEHÍCULOS</strong>
      </h5>
    </div>

    <div class="card-body">
      <div class="table-responsive mt-3">
        <table class="table table-bordered table-hover">
          <thead class="bg-primary text-white">
            <tr>
              <th class="text-center">PROCEDIMIENTO</th>
              <th class="text-center">PDF</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let documento of documentos">
              <td class="text-center text-uppercase">
                {{ documento.nombre }}
              </td>
              <td class="text-center">
                <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item delete">
                    <a href="javascript:void(0)">
                      <i class="icofont icofont-file-pdf" (click)="abrirDocumento()" ngbTooltip="Abrir Documento"></i>
                    </a>
                  </li>
                </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<!-- Modal PDF -->
<div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': mostrarModal }" *ngIf="mostrarModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-nombre">{{ pdfNombre }}</h5>
        <button type="button" class="btn-close" (click)="cerrarModal()"></button>
      </div>
      <div class="modal-body p-0">
        <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="700" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</div>

<!-- Fondo del modal -->
<div class="modal-backdrop fade show" *ngIf="mostrarModal"></div>